import { render, staticRenderFns } from "./twoColGoods.vue?vue&type=template&id=b6aeb4d6&scoped=true&"
import script from "./twoColGoods.vue?vue&type=script&lang=js&"
export * from "./twoColGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6aeb4d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6aeb4d6')) {
      api.createRecord('b6aeb4d6', component.options)
    } else {
      api.reload('b6aeb4d6', component.options)
    }
    module.hot.accept("./twoColGoods.vue?vue&type=template&id=b6aeb4d6&scoped=true&", function () {
      api.rerender('b6aeb4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/twoColGoods.vue"
export default component.exports